const BookIcon = ({ className, isSelected = false }) => {
  const fillColor = isSelected ? 'var(--forbrand-primary)' : 'var(--forbrand-secondary)'

  return (
    <div
      className={`${className} flex items-center justify-center w-[32px] h-[32px]`}
    >
     <svg width="24" height="24" viewBox="0 0 24 24" fill={fillColor} xmlns="http://www.w3.org/2000/svg">
<path d="M12.75 4.5H17.25L14.25 12H21.75L18.75 4.5V3H12.75V1.5H11.25V3H5.25V4.5L2.25 12H9.75L6.75 4.5H11.25V19.5H12.75V4.5ZM16.4806 10.5L18 6.67965L19.5194 10.5H16.4806ZM4.48058 10.5L6 6.67965L7.51942 10.5H4.48058ZM9.75 15H2.25V13.5H9.75V15ZM14.25 13.5H21.75V15H14.25V13.5ZM11.25 19.5L10.1997 21H5.25V19.5H11.25ZM12.75 19.5H18.75V21H12.75V19.5Z" fill="#111113"/>
</svg>


    </div>
  )
}

export default BookIcon
